import axios from "axios";
import { setupInterceptorsTo } from "./Interceptors";
import { URL_ENDPOINTS } from "../constants";

export const axiosInstance = setupInterceptorsTo(
  axios.create({
    baseURL: URL_ENDPOINTS.BASE_URL,
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: false,
  })
);

const Api = {
  GET: async (URL: string, params?: object): Promise<any>  => {
    const options = {
      params,
    };
    const request = await axiosInstance.get(URL, options);

    return request;
  },
  POST: async (URL: string, data: object): Promise<any> => {
    const request = await axiosInstance.post(URL, data);
    
    return request;
  },
  PUT: async (URL: string, data: object): Promise<any> => {
    const request = await axiosInstance.put(URL, data);

    return request;
  },
  PATCH: async (URL: string, data: object): Promise<any> => {
    const request = await axiosInstance.patch(URL, data);

    return request;
  }
};

export default Api;
